export default "__VITE_ASSET__140b586b__"